import Env from '../../base/env'

export default class List
{
    constructor(component)
    {
        this.view = component.view
        this.$list = component.$list
        this.$items = component.$listItems
        this.$cursor = component.view.querySelector('.jsList--visual')
        // Vars Cursor
        this.currentPosition = { x : 0 , y : 0 }
        this.newPosition = { x : 0 , y : 0 }
        this.inertia = 4
        // Flags
        this.CAN_MOUSEMOVE = false
        // Fns
        this.fnMousemove = this.getMousemove.bind(this)
        this.events()
    }

    destroy()
    {
        Env.$window.removeEventListener("mousemove", this.fnMousemove);
    }

    enableMousemove()
    {
        this.CAN_MOUSEMOVE = true
    }

    events()
    {
        Env.$window.addEventListener('mousemove',this.fnMousemove)


    }

    eventsItems()
    {
        for(let i = 0; i < this.$items.length; i++) {
            const $item = this.$items[i]
            const slug = $item.getAttribute('data-slug')
            const $visual = this.$cursor.querySelector(`.slug-${slug}`)

            $item.addEventListener('mouseenter',()=>{
                $visual.classList.add('is--active')
            })
            $item.addEventListener('mouseleave',()=>{
                $visual.classList.remove('is--active')
            })
        }
    }

    getMousemove(e)
    {
        this.currentPosition.x = e.clientX
        this.currentPosition.y = e.clientY
    }

    refresh(items)
    {
        this.$items = items
        this.eventsItems()
    }

    onWatch()
    {
        if(this.CAN_MOUSEMOVE === true) {
            this.newPosition.x += (this.currentPosition.x - this.newPosition.x) / this.inertia
            this.newPosition.y += (this.currentPosition.y - this.newPosition.y) / this.inertia
            TweenLite.set(this.$cursor , { x : this.newPosition.x , y : this.newPosition.y })
        }
    }
}